import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { suggestRlcsPlatformKey } from "../queryKeys";

interface Response {
  platform: string;
}

const useSuggestedRlcsPlatform = (hashValue?: string) => {
  const { data, isLoading } = useQuery<
    AxiosResponse<Response>,
    ErrorResponse,
    Response
  >({
    queryKey: suggestRlcsPlatformKey(hashValue),
    queryFn: () => api.suggestRlcsPlatform({ hashValue }),
    select: ({ data: response }) => response,
    enabled: !!hashValue
  });

  return {
    suggestedPlatform: data?.platform,
    isLoading
  };
};

export default useSuggestedRlcsPlatform;
